import {
    CatalogKindExploreContent,
    GroupsExplorerContent,
    ToolExplorerContent,
    ExploreLayout,
  } from '@backstage-community/plugin-explore';
  import { configApiRef, useApi } from '@backstage/core-plugin-api';
  //import { InnerSourceExploreContent } from './InnerSourceExploreContent';
  
  export const ExplorePage = () => {
    const configApi = useApi(configApiRef);
    const organizationName = configApi.getOptionalString('organization.name') ?? 'Backstage';

    return (
      <ExploreLayout
        title={`Explore the ${organizationName} ecosystem`}
        subtitle="Discover solutions available in our ecosystem"
      >
        <ExploreLayout.Route path="tools" title="Tools">
          <ToolExplorerContent />
        </ExploreLayout.Route>
        <ExploreLayout.Route path="domains" title="Domains">
          <CatalogKindExploreContent kind="domain" />
        </ExploreLayout.Route>
        <ExploreLayout.Route path="systems" title="Systems">
          <CatalogKindExploreContent kind="system" />
        </ExploreLayout.Route>
        <ExploreLayout.Route path="organization" title="Organization">
          <GroupsExplorerContent />
        </ExploreLayout.Route>
        <ExploreLayout.Route path="groups" title="Groups">
          <CatalogKindExploreContent kind="group" />
        </ExploreLayout.Route>
        <ExploreLayout.Route path="users" title="Users">
          <CatalogKindExploreContent kind="user" />
        </ExploreLayout.Route>
        {/*
        <ExploreLayout.Route path="inner-source" title="InnerSource">
          <InnerSourceExploreContent />
        </ExploreLayout.Route>
        */}
      </ExploreLayout>
    );
  };
  
  export const customExplorePage = <ExplorePage />;